import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { PreviousEVCode } from "../../../Data/Art57Data/PreviousEVCode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodePreviousEVCode extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new PreviousEVCode(new FieldDefinition(injector)),
        'Previous EV Code{param}'
      );
      this.parent = parent;
      this.labelNodeName = 'Previous EV Code';      
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      if (
        this.data &&
        this.data.model &&
        this.data.model.devevcode &&
        this.data.model.devevcode.value
      ) {
        this.label = this.data.model.devevcode.value;
      } else {
        this.label = 'Previous EV Code';
      }
    }
  
    override getListItem(): any[] {
      return [
        this.data.model &&
          this.data.model.type
          ? this.ioc!.get(LookupGetService).retrieveValueFromCache('productstypes', this.data.model.type)
          : '',
        this.data.model &&
          this.data.model.devevcode &&
          this.data.model.devevcode.value
          ? this.data.model.devevcode.value
          : 'Not selected',
      ];
    }
  
    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodePreviousEVCode = new TreeNodePreviousEVCode(
        this.ioc!,
        newParent
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
  }
  }
  